import {
  CHANGE_SIDE,
  CHANGE_DESIGN,
  SAVE_DESIGN,
  SUCCESS,
  CHANGE_BACKGROUND_FOR_OTHER_SIDES,
  CHANGE_PRODUCT,
  TOGGLE_STATIC_OBJECTS,
  SET_FILL_FOR_STATIC_OBJECT,
  RESTORE_DESIGN
} from "../constants/action-types";

export default (designs = {}, action) => {
  const {type, payload, response} = action;
  switch (type) {
    case CHANGE_SIDE:
      return {
        ...designs,
        [payload.prev.index]: {
          ...designs[payload.prev.index],
          design: payload.prev.design
        }
      };
    case CHANGE_DESIGN:
      return {
        ...designs,
        [payload.index]: {
          ...designs[payload.index],
          design: payload.design
        }
      };
    case SAVE_DESIGN + SUCCESS:
      return {
        ...designs,
        ...response.desings
      };
    case CHANGE_BACKGROUND_FOR_OTHER_SIDES:
      return {
        ...getDesignsWithChangedBg(designs, payload.color)
      };

    case CHANGE_PRODUCT + SUCCESS:
      return {
        ...response.designs,
        ...designs
      };

    case TOGGLE_STATIC_OBJECTS:
      return {
        ...payload.designs
      };

    case SET_FILL_FOR_STATIC_OBJECT:
      return {
        ...getDesignsWithChangedFill(
          designs,
          payload.fillColor,
          payload.pathNumber
        )
      };

    case RESTORE_DESIGN:
      return {
        ...payload.designs
      };
  }
  return designs;
};

function getDesignsWithChangedBg(designs, color) {
  const newDesigns = {...designs};
  for (const key in newDesigns) {
    if (newDesigns.hasOwnProperty(key)) {
      const design = newDesigns[key].design;
      design.background = color;
    }
  }
  return newDesigns;
}

function getDesignsWithChangedFill(designs, fillColor, pathNumber) {
  const newDesigns = {...designs};
  for (const key in newDesigns) {
    if (newDesigns.hasOwnProperty(key)) {
      const {design} = newDesigns[key];
      if (design.objects) {
        const staticObjects = design.objects.filter((o) => o.static);
        if (staticObjects.length) {
          if (staticObjects[0].objects) {
            staticObjects[0].objects[pathNumber].fill = fillColor;
          } else {
            staticObjects[0].fill = fillColor;
          }
        }
      }
    }
  }
  return newDesigns;
}
